export default __webpack_public_path__ + "btn_remind_share_light_round_normal_2x.png";